










import { Vue, Component } from 'vue-property-decorator';
import ConfigAutorizaciones from '@/pantallas/Conecta/ConfigAutorizaciones/ConfigAutorizaciones.vue';

@Component({ components: { ConfigAutorizaciones } })
export default class SimSolicitudesPantalla extends Vue {}
